import React, { useEffect, useState } from 'react';
import { Container } from 'reactstrap';
import DriverVehicleMapping from './components/DriverVehicleMapping';
import DriverVehcileMappingModal from './components/DriverVehcileMappingModal';
import SnackbarContent from '@mui/material/SnackbarContent';
import LinearProgress from '@mui/material/LinearProgress';
import { Box } from '@mui/material';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import { showNotification, successNofication } from 'src/shared/components/Notification';
import ConfirmationDialog from 'src/shared/components/ConfirmationDialog';
import PndRestApi from 'src/utils/pnd/PndRestApi';
import { ERROR_MESSAGES } from 'src/utils/pnd/PndConstants';
import PageHeader from 'src/shared/components/layout/PageHeader';

const DriverVehicleMappingDetailsIndex = () => {
  useEffect(() => {
    getAllHubAssignedDriverDetails();
  }, [])

  const [reactTableData, setReactTableData] = useState([]);
  const [temp, setTempData] = useState("");
  const [viewDetailPopup, setViewDetailPopup] = useState(false);
  const [isTitle, setTitle] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isDeleteData, setDeleteData] = useState(null);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [isNoRecordFound, setNoRecordFound] = useState(false);
  const [isRedirect, setIsRedirect] = useState(false);

  const getAllHubAssignedDriverDetails = async () => {
    try {
      setLoading(true);
      const response = await PndRestApi.GetAllHubAssignedDriverDetails();
      if (response.status === 200 && response.data.status === 200) {
        setReactTableData({ tableRowsData: response.data.data });
      } else if (response?.data?.status && response?.data?.status === 204) {
        setNoRecordFound(true);
      } else {
        showNotification(
          "theme-light",
          "ltr",
          `SuccessCode: ${response.data.status}`,
          `Message:${response.data.message}`,
        );
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      showNotification(
        "theme-light",
        "ltr",
        `SuccessCode: 500`,
        ERROR_MESSAGES.tryCatchError,
      );
    } finally {
      setLoading(false);
    }
  };

  if (isRedirect) {
    window.location.reload();
  }

  const handleUnassign = async (rowData) => {
    if (rowData?.driverId) {
      try {
        setLoading(true);
        let Obj = {};
        Obj["driverId"] = rowData?.driverId;
        const response = await PndRestApi.CheckOrderAssignedToRider(Obj);
        if (response.status === 200 && response.data.status === 204) {
          setShowConfirmation(true); // Show confirmation dialog
          setDeleteData(rowData); // Store data for unassignment
        } else {
          showNotification(
            "theme-light",
            "ltr",
            `SuccessCode: ${response.data.status}`,
            `Message:${response.data.message}`,
          );
        }
      } catch (error) {
        console.error('Error fetching data:', error);
        showNotification(
          "theme-light",
          "ltr",
          `SuccessCode: 500`,
          ERROR_MESSAGES.tryCatchError,
        );
      } finally {
        setLoading(false);
      }
    }
  };

  const handleCancelUnassign = () => {
    setShowConfirmation(false);
  };

  const handleConfirmDelete = async () => {
    try {
      let obj = {};
      obj["driverId"] = isDeleteData?.driverId;
      obj["vehicleId"] = isDeleteData?.vehicleId;
      obj["assignOrUnAssign"] = false; /** Assign - true, Unassign - false**/
      const response = await PndRestApi.AssignUnAssignVehicleToRider(obj);
      if (response.status === 200 && response.data.status === 200) {
        successNofication(
          "theme-light",
          "ltr",
          `SuccessCode: ${response.data.status}`,
          ERROR_MESSAGES.successMessage,
        );
        setIsRedirect(true);
      } else {
        showNotification(
          "theme-light",
          "ltr",
          `SuccessCode: ${response.data.status}`,
          `Message:${response.data.message}`,
        );
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      showNotification(
        "theme-light",
        "ltr",
        `SuccessCode: 500`,
        ERROR_MESSAGES.tryCatchError,
      );
    } finally {
      setShowConfirmation(false);
    }
  };

  const edit = async (event) => {
    if (event.driverId) {
      setTempData(event);
      setViewDetailPopup(true);
      setTitle("Assign Vehicle to Driver ");
    }
  };

  return (
    <Box sx={{ p: 3, backgroundColor: '#f8fafc', minHeight: '100vh' }}>
      <Container fluid style={{ maxWidth: '1400px' }}>
        <PageHeader
          icon={<DirectionsCarIcon fontSize="large" />}
          title="Driver-Vehicle Mapping"
          subtitle="Assign and manage vehicle allocations for individual riders."
          gradient="linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%)"
        />

        {loading && <LinearProgress sx={{ mb: 2, borderRadius: 2 }} />}

        <Box sx={{ position: 'relative' }}>
          {(reactTableData && reactTableData != null && reactTableData.tableRowsData != null) && !isNoRecordFound && (
            <DriverVehicleMapping
              reactTableData={reactTableData}
              onAssign={edit}
              onUnassign={handleUnassign}
              isNoRecordFound={isNoRecordFound}
            />
          )}
          {isNoRecordFound && (
            <DriverVehicleMapping
              isNoRecordFound={isNoRecordFound}
              onAssign={edit}
              onUnassign={handleUnassign}
            />
          )}
          {/* {isNoRecordFound && <SnackbarContent message={"No Record Found"} />} */}
        </Box>

        {viewDetailPopup &&
          <DriverVehcileMappingModal
            modalShow={viewDetailPopup}
            setModalShow={setViewDetailPopup}
            driverData={temp}
            isTitle={isTitle}
          />}

        {showConfirmation && (
          <ConfirmationDialog
            open={showConfirmation}
            onClose={handleCancelUnassign}
            onConfirm={handleConfirmDelete}
            title="Confirmation"
            message="Are you sure you want to permanently remove the vehicle from this Driver?"
          />
        )}
      </Container>
    </Box>
  );
};

export default DriverVehicleMappingDetailsIndex;